import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

type FeatureKey = keyof typeof environment.featureManagement;

interface MenuItem {
  heading: string;
  icon: string;
  link: string;
  visibleIn: FeatureKey[];
  children: MenuChild[];
}

interface MenuChild {
  title: string;
  link: string;
  icon: string;
  visibleIn?: FeatureKey[];
}

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NavComponent implements OnInit {
  data: MenuItem[] = [];
  title: string = 'ADMINISTRADOR';

  constructor(public authService: AuthService, private router: Router) {}

  isHideSearchRoute(): boolean {
    const currentUrl = this.router.url;
    return (
      currentUrl.includes('address-form') ||
      currentUrl.includes('cost-table') ||
      currentUrl.includes('particular-orders-list') ||
      currentUrl.includes('pricing-rules')
    );
  }

  private isVisible(features?: FeatureKey[]): boolean {
    if (!features || features.length === 0) return true;
    return features.some(
      feature => environment.featureManagement[feature] === true
    );
  }

  ngOnInit(): void {
    this.data = this.adminItems
      .filter(item => this.isVisible(item.visibleIn))
      .map(item => ({
        ...item,
        children: item.children.filter(child => this.isVisible(child.visibleIn))
      }));
  }

  adminItems: MenuItem[] = [
    {
      heading: 'Panel',
      icon: 'api',
      link: '',
      visibleIn: ['reDelivery'],
      children: [
        {
          title: 'Gestion de Usuario',
          link: 'editar-admin',
          icon: 'account_circle',
        },
        {
          title: 'Cambiar Contraseña',
          link: 'pass-management',
          icon: 'vpn_key',
        },
      ],
    },
    {
      heading: 'Banners',
      icon: 'filter',
      link: '',
      visibleIn: ['reDelivery'],
      children: [
        {
          title: 'Banners',
          link: 'banners-management',
          icon: 'image',
        },
        {
          title: 'Slider de Inicio',
          link: 'start-slider',
          icon: 'filter',
        },
      ],
    },
    {
      heading: 'Administrar ciudades',
      icon: 'place',
      link: 'city-management',
      visibleIn: ['reDelivery'],
      children: [],
    },
    {
      heading: 'Páginas de la aplicación',
      icon: 'content_copy',
      link: 'app-pages-management',
      visibleIn: ['reDelivery'],
      children: [],
    },
    {
      heading: 'Comercios',
      icon: 'store',
      link: '',
      visibleIn: ['reDelivery'],
      children: [
        {
          title: 'Administrar comercios',
          link: 'adm-comercio',
          icon: 'storefront',
        },
        {
          title: 'Administrar tipos de comercio',
          link: 'shop-type-management',
          icon: 'list',
        },
      ],
    },
    {
      heading: 'Administrar descuentos',
      icon: 'local_offer',
      link: 'discount-management',
      visibleIn: ['reDelivery'],
      children: [],
    },
    {
      heading: 'Cadetes',
      icon: 'people',
      link: 'personal',
      visibleIn: ['reDelivery', 'coopExpress'],
      children: [],
    },
    {
      heading: 'Clientes',
      icon: 'people',
      link: 'clientes',
      visibleIn: ['reDelivery', 'coopExpress'],
      children: [],
    },
    {
      heading: 'Mensajería',
      icon: 'moped',
      link: '',
      visibleIn: ['reDelivery', 'coopExpress'],
      children: [
        {
          title: 'Listado de envíos',
          link: 'particular-orders-list',
          icon: 'groups',
        },
        {
          title: 'Envío nuevo',
          link: 'address-form',
          icon: 'route',
        },
        {
          title: 'Reglas de costos',
          link: 'cost-table',
          icon: 'request_quote',
          visibleIn: ['reDelivery'],
        },
        {
          title: 'Reglas de precios',
          link: 'pricing-rules',
          icon: 'request_quote',
        },
      ],
    },
    {
      heading: 'Punto Fijo',
      icon: 'location_on',
      link: '',
      visibleIn: ['reDelivery', 'coopExpress'],
      children: [
        {
          title: 'Registros de turnos',
          link: 'delivery-records',
          icon: 'schedule',
        },
        {
          title: 'Reglas de costos por hora',
          link: 'fixed-point-pricing-rules',
          icon: 'request_quote',
        },
      ],
    },
    {
      heading: 'Administrar pedidos',
      icon: 'shopping_cart',
      link: '',
      visibleIn: ['reDelivery'],
      children: [
        {
          title: 'Pedidos Activos',
          link: 'active-orders',
          icon: 'double_arrow',
        },
        {
          title: 'Pedidos Rechazados',
          link: 'cancelled-orders',
          icon: 'do_disturb',
        },
        // {
        //   title: "Pedidos Asignados a Cadete",
        //   link: 'assigned-orders',
        //   icon: 'done_all',
        // },
        {
          title: 'Pedidos En Viaje',
          link: 'completed-orders',
          icon: 'double_arrow',
        },
      ],
    },
    {
      heading: 'Enviar notificación',
      icon: 'send',
      link: 'notifications',
      visibleIn: ['reDelivery'],
      children: [],
    },
    {
      heading: 'Liquidaciones',
      icon: 'stacked_line_chart',
      link: '',
      visibleIn: ['reDelivery', 'coopExpress'],
      children: [
        {
          title: 'Cadetes',
          link: 'liquidaciones-cadetes',
          icon: 'sports_motorsports',
          visibleIn: ['reDelivery'],
        },
        {
          title: 'Mensajería',
          link: 'liquidaciones-particular-orders',
          icon: 'sports_motorsports',
          visibleIn: ['coopExpress'],
        },
        {
          title: 'Punto Fijo',
          link: 'liquidaciones-work-shift-sessions',
          icon: 'sports_motorsports',
          visibleIn: ['coopExpress'],
        },
        {
          title: 'Empresas',
          link: 'liquidaciones-empresas',
          icon: 'work',
          visibleIn: ['reDelivery'],
        },
        {
          title: 'Recibos cadetes',
          link: 'recibos-cadetes',
          icon: 'sports_motorsports',
          visibleIn: ['reDelivery'],
        },
        {
          title: 'Liquidación Clientes',
          link: 'liquidaciones-clientes',
          icon: 'business',
          visibleIn: ['coopExpress'],
        },
      ],
    },
    {
      heading: 'Reportes',
      icon: 'stacked_line_chart',
      link: '',
      visibleIn: ['reDelivery', 'coopExpress'],
      children: [
        {
          title: 'Reportes de Ventas',
          link: 'sales-report',
          icon: 'list',
          visibleIn: ['reDelivery'],
        },
        // {
        //   title: 'Reportes de Cadetes',
        //   link: 'delivery-report',
        //   icon: 'list',
        // },
        {
          title: 'Consultar liquidaciones',
          link: 'consulta-liquidaciones',
          icon: 'analytics',
          visibleIn: ['reDelivery', 'coopExpress'],
        },
        {
          title: 'Consultar recibos',
          link: 'consulta-recibos-cadetes',
          icon: 'receipt',
          visibleIn: ['reDelivery'],
        },
      ],
    },
    {
      heading: 'Herramientas adicionales',
      icon: 'addchart',
      link: 'admin-home',
      visibleIn: ['reDelivery'],
      children: [],
    },
    {
      heading: 'Usuarios de app',
      icon: 'groups',
      link: 'app-users',
      visibleIn: ['reDelivery'],
      children: [],
    },
    {
      heading: 'Salir',
      icon: 'exit_to_app',
      link: 'login-admin',
      visibleIn: ['reDelivery', 'coopExpress'],
      children: [],
    },
  ];
}
